var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.186 3.0747C10.0666 3.02686 9.93338 3.02686 9.814 3.0747L3.846 5.4617L6.25 6.4227L12.404 3.9617L10.186 3.0747ZM13.75 4.5007L7.596 6.9617L10 7.9227L16.154 5.4617L13.75 4.5007ZM17 6.2007L10.5 8.8007V16.7227L17 14.1227V6.2007ZM9.5 16.7237V8.7997L3 6.2007V14.1237L9.5 16.7237ZM9.443 2.1457C9.80057 2.0027 10.1994 2.0027 10.557 2.1457L17.686 4.9977C17.7787 5.03485 17.8581 5.0989 17.9141 5.18159C17.9701 5.26429 18 5.36185 18 5.4617V14.1237C17.9999 14.3235 17.9399 14.5187 17.8278 14.6841C17.7157 14.8495 17.5566 14.9776 17.371 15.0517L10.186 17.9257C10.0666 17.9735 9.93338 17.9735 9.814 17.9257L2.63 15.0517C2.44425 14.9777 2.28494 14.8498 2.17264 14.6843C2.06034 14.5189 2.00021 14.3236 2 14.1237V5.4617C2.00002 5.36185 2.02994 5.26429 2.08591 5.18159C2.14187 5.0989 2.22131 5.03485 2.314 4.9977L9.443 2.1457Z",
    fill: "#50515C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactIcon2);
export default __webpack_public_path__ + "static/media/fact-icon2.56b4d4ccea0e552c92187888008c5fce.svg";
export { ForwardRef as ReactComponent };